"use strict";

/* A service / model */

_BannerFlowApp.factory("Page", function ($location, AuthInfo, History) {
    return {
        _isSettings: false,
        Init: function (isSettings) {
            this._isSettings = isSettings;
        },
        Previous: {},
        SetPrevious: function (name, path, params, isRoot, queryString) {
            this.Previous = {
                root: isRoot,
                path: path,
                params: params,
                queryString: queryString
            };

            if (isRoot) {
                if (this._isSettings) {
                    var previousBrand = History.GetLastVisitedBrand();
                    if (previousBrand) {
                        this.Previous.name = previousBrand.name;
                        this.Previous.path = previousBrand.path;
                    } else {
                        this.Previous.name = "Back";
                        this.Previous.path = "/{0}/{1}".format(
                            AuthInfo.LoggedInUser.currentAccount.slug,
                            AuthInfo.LoggedInUser.currentBrand.slug
                        );
                    }
                } else {
                    this.Previous.name = "Home";
                }
            } else {
                this.Previous.name = name;
            }
        },
        GetPreviousLocation: function () {
            var previous = JSON.parse(window.localStorage.getItem("pb"));
            if (previous) {
                return {
                    name: previous.n,
                    path: previous.l
                };
            } else {
                return {};
            }
        },
        SaveCurrentLocation: function (id) {
            var location = {
                n: AuthInfo.LoggedInUser.currentBrand.name,
                l: $location.$$path
            };

            if (id) {
                location.id = id;
            }

            window.localStorage.setItem("pb", JSON.stringify(location));
        }
    };
});
